<script>
export default {
    name: "ReceivedPaymentsReport",

    data() {

        return {
            filter: {
                search: ``,
                dateFrom: window.moment().format(`YYYY-MM-DD`),
                dateTo: window.moment().format(`YYYY-MM-DD`),
            },
            payments: [],
        };
    },

    computed: {

        totalPaidAmt() {
            if(!this.payments.length && !this.payments.billPaymentsReport) return 0;

            if(!this.payments.billPaymentsReport.length) return 0;

            return this.payments.billPaymentsReport.map(payment => payment.amount ? parseFloat(payment.amount) : 0)
                .reduce((amt,sum ) => amt+sum);
        },

        totalCreditAmt() {
            if(!this.payments.length && !this.payments.billPaymentsReport) return 0;

            if(!this.payments.billPaymentsReport.length) return 0;

            return this.payments.billPaymentsReport.map(payment => payment.creditAmount ? parseFloat(payment.creditAmount) : 0)
                .reduce((amt,sum ) => amt+sum);
        },

        totalReceiptAmt() {
            if(!this.payments.length && !this.payments.billPaymentsReport) return 0;

            if(!this.payments.billPaymentsReport.length) return 0;

            return this.payments.billPaymentsReport.map(payment => payment.receiptAmount ? parseFloat(payment.receiptAmount) : 0)
                .reduce((amt,sum ) => amt+sum);
        },

        totalDepositAmt() {
            if(!this.payments.length && !this.payments.depositsReport) return 0;

            if(!this.payments.depositsReport.length) return 0;

            return this.payments.depositsReport.map(dep => dep.depositAmount ? parseFloat(dep.depositAmount) : 0)
                .reduce((amt,sum ) => amt+sum);
        },

        totalAllocatedAmt() {
            if(!this.payments.length && !this.payments.depositsReport) return 0;

            if(!this.payments.depositsReport.length) return 0;

            return this.payments.depositsReport.map(dep => dep.amountAllocated ? parseFloat(dep.amountAllocated) : 0)
                .reduce((amt,sum ) => amt+sum);
        },

        totalUnallocatedAmt() {
            if(!this.payments.length && !this.payments.depositsReport) return 0;

            if(!this.payments.depositsReport.length) return 0;

            return this.payments.depositsReport.map(dep => dep.unAllocatedAmount ? parseFloat(dep.unAllocatedAmount) : 0)
                .reduce((amt,sum ) => amt+sum);
        },
        totalSalesAmt() {
            if(!this.payments.length && !this.payments.salesReport) return 0;

            if(!this.payments.salesReport.length) return 0;

            return this.payments.salesReport.map(dep => 
                    dep.totalAmount ? parseFloat(dep.totalAmount) : 0)
                .reduce((amt,sum ) => amt+sum);
        },
        totalSalesPaidAmt() {
            if(!this.payments.length && !this.payments.salesReport) return 0;

            if(!this.payments.salesReport.length) return 0;

            return this.payments.salesReport.map(dep => 
                    dep.paidAmount ? parseFloat(dep.paidAmount) : 0)
                .reduce((amt,sum ) => amt+sum);
        },totalSalesbalanceAmt() {
            if(!this.payments.length && !this.payments.salesReport) return 0;

            if(!this.payments.salesReport.length) return 0;

            return this.payments.salesReport.map(dep => 
                    dep.balance ? parseFloat(dep.balance) : 0)
                .reduce((amt,sum ) => amt+sum);
        },

        totalCashOut() {

            if(!this.payments.length && !this.payments.cashReport ) return 0;

            if(!this.payments.cashReport.length) return 0;

            return this.payments.cashReport.map(cOut => cOut.amount ? parseFloat(cOut.amount) : 0)
                .reduce((amt,sum ) => amt+sum);
        },

        totalReceivedAmount() {

            return this.totalPaidAmt + this.totalDepositAmt+ this.totalSalesPaidAmt;
        },

        tillAmount() {

            return this.totalReceivedAmount - (this.totalCreditAmt + this.totalCashOut);
        },
    },

    mounted() {
        this.$root.loading=true;
        Promise.allSettled([ this.fetchReceivedPayments(), ]).then(() => {
            this.$root.loading=false;
            setTimeout(() => {
                window.print();
            }, 250);
        }).catch(() => { this.$root.loading=false; });
    },

    methods: {

        fetchReceivedPayments() {
            if(!this.filter.dateFrom && !this.filter.dateTo) return Promise.reject();

            let url = `AccountsReports/GetReceivedPayments`;
                url += `?Datefrom=${this.$route.query.dateFrom}&Dateto=${this.$route.query.dateTo}`;
                url += this.$route.query.Cashier ? `&Cashier=${this.$route.query.Cashier}` : ``;
                url += this.$route.query.PaymentMode ? `&PaymentMode=${this.$route.query.PaymentMode}` : ``;
                url += this.$route.query.search ? `&SearchText=${this.$route.query.search}` : ``;

            return this.$http.get(url).then(response => { 
                    this.payments = response.data; 
                }).catch(() => {});
        },
        RecordUserActivity() {
          this.userActivityModels.userActivity="Page Access: "+this.$root.username+": Successfully Accessed Received Payment Report";
          this.userActivityModels.userHostAddress=window.location.host;
          this.userActivityModels.userHostAddress=window.location.hostname;
          
          this.$root.loading = true;
                this.$http.post(`Admin/RecordUserActivity`, this.userActivityModels).then(response => {
                     
                  this.responsemsg= response.data;
                    this.$root.loading = false;
                 }).catch(() => { this.$root.loading = false; });

          
        },
    },
}
</script>
<template>
<div class="flex flex-wrap content-start">
    <div class="w-full my-2 p-1 text-center">
        <h5 class="font-bold text-base">Received Payments report</h5>
    </div>
    <div class="w-full p-tiny">
        <h5 class="font-semibold text-base">Payments Against Bills</h5>
    </div>
    <table class="table" id="receivedPaymentsReport">
        <tbody class="text-xs">
            <tr>
                <th class="p-tiny">Time (d-m-y)</th>
                <th class="p-tiny">Patient</th>
                <th class="p-tiny">IPFile No</th>
                <th class="p-tiny">OPFile No</th>
                <th class="p-tiny">Receipt No</th>
                <th class="p-tiny">Mode</th>
                <th class="p-tiny">Paid</th>
                <th class="p-tiny">Reversed</th>
                <th class="p-tiny">Receipt</th>
                <th class="p-tiny">Memo</th>
                <th class="p-tiny">Username</th>
            </tr>
            <tr v-for="(payment, idx) in payments.billPaymentsReport" :key="idx">
                <td class="p-tiny">{{ payment.sysDate }}</td>
                <td class="p-tiny">{{ payment.patient }}</td>
                <td class="p-tiny">{{ payment.ipfileno || `-` }}</td>
                <td class="p-tiny">{{ payment.opfileno || `-` }}</td>
                <td class="p-tiny">{{ payment.receipt_No || `-` }}</td>
                <td class="p-tiny">{{ payment.mode }}</td>
                <td class="p-tiny">{{ payment.amount | numberFormat }}</td>
                <td class="p-tiny">{{ payment.creditAmount | numberFormat }}</td>
                <td class="p-tiny">{{ payment.receiptAmount | numberFormat }}</td>
                <td class="p-tiny">{{ payment.refNo || `-` }}</td>
                <td class="p-tiny">{{ payment.userName }}</td>
            </tr>
            <tr>
                <th scope="row" colspan="8" class="p-tiny"></th>
                <th scope="row" class="p-tiny">Paid Amt: {{ totalPaidAmt | numberFormat }}</th>
                <th scope="row" class="p-tiny">Credit Amt: {{ totalCreditAmt | numberFormat }}</th>
                <th scope="row" class="p-tiny">Receipt Amt: {{ totalReceiptAmt | numberFormat }}</th>
            </tr>
        </tbody>
    </table>
    <div class="w-full p-tiny">
        <h5 class="font-semibold text-base">Deposits Received</h5>
    </div>
    <table class="table" id="receivedDepositsReport">
        <tbody class="text-xs">
            <tr>
                <th class="p-tiny">Date</th>
                <th class="p-tiny">Patient</th>
                <th class="p-tiny">IPFile No</th>
                <th class="p-tiny">OPFile No</th>
                <th class="p-tiny">Receipt No</th>
                <th class="p-tiny">Type</th>
                <th class="p-tiny">Mode</th>
                <th class="p-tiny">User</th>
                <th class="p-tiny">Amount</th>
                <th class="p-tiny">Allocated</th>
                <th class="p-tiny">Un-allocated</th>
                <th class="p-tiny">Memo</th>
            </tr>
            <tr v-for="(payment, idx) in payments.depositsReport" :key="idx">
                <td class="p-tiny">{{ payment.trxDate | dateFormat }}</td>
                <td class="p-tiny">{{ payment.names }}</td>
                <td class="p-tiny">{{ payment.ipfileno || `-` }}</td>
                <td class="p-tiny">{{ payment.opfileno || `-` }}</td>
                <td class="p-tiny">{{ payment.receiptNo }}</td>
                <td class="p-tiny">{{ payment.paymentType }}</td>
                <td class="p-tiny">{{ payment.mode }}</td>
                <td class="p-tiny">{{ payment.userName || `-` }}</td>
                <td class="p-tiny">{{ payment.depositAmount | numberFormat }}</td>
                <td class="p-tiny">{{ payment.amountAllocated | numberFormat }}</td>
                <td class="p-tiny">{{ payment.unAllocatedAmount | numberFormat }}</td>
                <td class="p-tiny">{{ payment.trxMemo || `-` }}</td>
            </tr>
            <tr>
                <th scope="row" colspan="9" class="p-tiny flex-1"></th>
                <th scope="row" class="p-tiny flex-1">Total Amt: {{ totalDepositAmt | numberFormat }}</th>
                <th scope="row" class="p-tiny flex-1">Total Allocated: {{ totalAllocatedAmt | numberFormat }}</th>
                <th scope="row" class="p-tiny flex-1">Un-allocated: {{ totalUnallocatedAmt | numberFormat }}</th>
            </tr>
        </tbody>
    </table>
    <div class="w-full p-tiny" v-if="$root.checkAuth(`ViewPOSSalesReport`)">
                <h5 class="font-semibold text-base">POS Sales Payment</h5> 
            </div>
            <table class="table table-hover" id="receivedDepositsReport" v-if="$root.checkAuth(`ViewPOSSalesReport`)">
                <thead class="bg-blue-500 text-xs text-white">
                      <tr class="w-full flex">
                          <th class="p-tiny w-1/12">Date</th>
                          <th class="p-tiny w-1/6">Receipt No</th>
                          <th class="p-tiny flex-1">Sales No</th>
                          <th class="p-tiny flex-1">Customer Name</th>
                          <th class="p-tiny flex-1">Ref</th>
                          <th class="p-tiny flex-1">Mode</th>
                          <th class="p-tiny flex-1">User</th>
                          <th class="p-tiny flex-1">Amount</th>
                          <th class="p-tiny flex-1">Paid</th>
                          <th class="p-tiny flex-1">Balance</th>
                          <!-- <th class="p-tiny w-1/6">Memo</th> -->
                          <th class="p-tiny w-1/12">Print</th>
                      </tr>
                </thead>
                <tfoot>
                    <tr class="w-full flex">
                        <th colspan="3" class="p-tiny flex-1"></th>
                        <th class="p-tiny flex-1">
                            Total Amt: {{ totalSalesAmt | numberFormat }}</th>
                        <th class="p-tiny flex-1">
                            Total Paid: {{ totalSalesPaidAmt | numberFormat }}</th>
                        <th class="p-tiny flex-1">
                            Balance: {{ totalSalesbalanceAmt | numberFormat }}</th>
                    </tr>
                </tfoot>
                <tbody class="text-xs bg-gray-100 flex flex-col items-center overflow-auto">
                    <tr class="w-full flex" 
                        v-for="(payment, idx) in payments.salesReport" :key="idx">
                        <td class="p-tiny w-1/12">{{ payment.txnDate | dateFormat }}</td>
                        <td class="p-tiny w-1/6">{{ payment.receiptNo }}</td>
                        <td class="p-tiny flex-1">{{ payment.billNo || `-` }}</td>
                        <td class="p-tiny flex-1">{{ payment.customerName || `-` }}</td>
                        <td class="p-tiny flex-1">{{ payment.ref }}</td>
                         <td class="p-tiny flex-1">{{ payment.mode }}</td>
                        <td class="p-tiny flex-1">{{ payment.userName || `-` }}</td>
                        <td class="p-tiny flex-1">{{ payment.totalAmount | numberFormat }}</td>
                        <td class="p-tiny flex-1">{{ payment.paidAmount | numberFormat }}</td>
                        <td class="p-tiny flex-1">{{ payment.balance | numberFormat }}</td>
                          <!-- <td class="p-tiny w-1/6">{{ payment.trxMemo }}</td> -->
                        <td class="p-tiny w-1/12">
                            <button
                                @click.prevent="printPOSSalesReceipt(payment.receiptNo)" 
                                class="btn-sm btn-info text-xs rounded m-px">
                                    <i class="fa fa-print"></i> Receipt</button>
                          
                        </td>
                    </tr>
                </tbody>
            </table><div class="w-full p-tiny">
        <h5 class="font-semibold">Approved Cash Out</h5>
    </div>
    <table class="table" id="approvedCashOutReport">
        <tbody class="text-xs">
            <tr>
                <th class="p-tiny">Authorized By</th>
                <th class="p-tiny">Received By</th>
                <th class="p-tiny">Item</th>
                <th class="p-tiny">Memo</th>
                <th class="p-tiny">Qty</th>
                <th class="p-tiny">Username</th>
                <th class="p-tiny">Approved By</th>
                <th class="p-tiny">Amount</th>
            </tr>
            <tr v-for="(payment, idx) in payments.cashReport" :key="idx">
                <td class="p-tiny">{{ payment.authorisedBy }}</td>
                <td class="p-tiny">{{ payment.receivedBy }}</td>
                <td class="p-tiny">{{ payment.item }}</td>
                <td class="p-tiny">{{ payment.memo || `-` }}</td>
                <td class="p-tiny">{{ payment.quantity }}</td>
                <td class="p-tiny">{{ payment.userName || `-` }}</td>
                <td class="p-tiny">{{ payment.approvedBy || `-` }}</td>
                <td class="p-tiny">{{ payment.amount | numberFormat }}</td>
            </tr>
            <tr>
                <th scope="row" colspan="6"></th>
                <th scope="row" colspan="2" class="text-right">
                    Total Amount: {{ totalCashOut | numberFormat }}</th>
            </tr>
        </tbody>
    </table>
    <div class="w-full p-1 text-center">
        <h5 class="font-bold text-base">Total Periodic Collections</h5>
    </div>
    <div class="w-full flex flex-row bg-gray-300 p-1 my-1">
        <div class="flex-1">
            <h5 class="font-semibold text-base">
                Received Amount: {{ totalReceivedAmount | numberFormat }}</h5>
        </div>
        <div class="flex-1">
            <h5 class="font-semibold text-base">
                Credit Amount: {{ totalCreditAmt | numberFormat }}</h5>
        </div>
        <div class="flex-1">
            <h5 class="font-semibold text-base">Cash Out: {{ totalCashOut | numberFormat }}</h5>
        </div>
        <div class="flex-1">
            <h5 class="font-semibold text-base">Till Amount: {{ tillAmount | numberFormat }}</h5>
        </div>
    </div>
</div>
</template>
